import { render, staticRenderFns } from "./CreateNewUser.vue?vue&type=template&id=107bf33f&scoped=true"
import script from "./CreateNewUser.vue?vue&type=script&lang=js"
export * from "./CreateNewUser.vue?vue&type=script&lang=js"
import style0 from "./CreateNewUser.vue?vue&type=style&index=0&id=107bf33f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107bf33f",
  null
  
)

export default component.exports